import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Store } from "@ngrx/store";
import { map, take } from "rxjs/operators";
import { LogLevel } from "src/components/shared-components/enum/enumLog";
import { environment } from "src/environments/environment";
import { LoggerService } from "src/service/logger.service";
import { isUserAuthenticated } from "src/state/selectors/authentication.selectors";

/**
 * handle page deactivation page
 */
@Injectable({
  providedIn: "root",
})
export class PageDeactivationGuard {
  private _logContext: string = "Page-deactivate.guard";

  constructor(
    private _loggerService: LoggerService,
    private _store: Store,
  ) {}

  canDeactivate(
    component: any,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot,
  ): any {
    this._loggerService.log(
      LogLevel.LOG_INFO,
      this._logContext,
      this._logContext,
      "canDeactivate",
      " CURRENT STATE: " + currentState + " | NEXT STATE: " + nextState,
    );
    this._loggerService.log(
      LogLevel.LOG_INFO,
      this._logContext,
      this._logContext,
      "canDeactivate",
      "CURRENT STATE URL: " + currentState.url,
    );
    this._loggerService.log(
      LogLevel.LOG_INFO,
      this._logContext,
      this._logContext,
      "canDeactivate",
      "NEXT STATE URL: " + nextState.url,
    );

    return this._store.select(isUserAuthenticated).pipe(
      take(1),
      map((isAuthenticated: boolean) => {
        const canOpenRoute: boolean = !(
          //#region BIGStudio3
          /*
            nextState.url === "/intermediate" ||
            nextState.url === "/local/plant/list" ||
            nextState.url === "/local/plant/login" ||
            nextState.url === "/splash" ||
*/
          (
            nextState.url === "/intermediate" ||
            nextState.url.includes("/local/plant") ||
            nextState.url === "/splash" ||
            nextState.url.includes("/backup-settings") ||
            //#endregion
            //#region DigitalPLace
            nextState.url === "/login" ||
            nextState.url.includes("/create-account") ||
            nextState.url === "/request-change-pwd"
          )
          //#endregion
        );
        let nextStep: boolean | UrlTree = false;

        this._loggerService.log(
          LogLevel.LOG_INFO,
          this._logContext,
          "_authService",
          "userIsAuthenticated",
          "User is Authenticated:  " +
            isAuthenticated +
            "| User can open route: " +
            canOpenRoute,
        );

        //CASE A: "accessToken" property is valorized AND we are moving towards a "protected" page.
        if (isAuthenticated && canOpenRoute) {
          nextStep = true;
        } else {
          //CASE B: "accessToken" property is valorized BUT we are moving towards a "public" page.
          //OR
          //CASE C: "accessToken" property is NOT valorized BUT we are moving towards a "protected" page
          if (
            (isAuthenticated && !canOpenRoute) ||
            (!isAuthenticated && canOpenRoute)
          ) {
            nextStep = false;
          } else {
            //CASE D: "accessToken" property is NOT valorized AND we are moving towards a "public" page.
            nextStep = true;
          }
        }

        //PECULIAR CASE. Pages which can be accessed both from "public" and "protected" pages.
        if (nextState.url.includes("/reserved-area/settings")) {
          nextStep = true;
        }

        //#region PECULIAR CASE. BEHAVIUOR FOR DigitalPlace-only, registration-related (not-protected) pages
        if (
          (currentState.url.includes("/reserved-area/reset-password") &&
            nextState.url !== "/login") ||
          (currentState.url.includes("/reserved-area/accept-invitation") &&
            nextState.url !== "/login") ||
          (currentState.url.includes("/reserved-area/invite-response") &&
            nextState.url !== "/login" &&
            !nextState.url.includes("/create-account")) ||
          (currentState.url.includes("/registration-confirmation") &&
            nextState.url !== "/login")
        ) {
          nextStep = false;
        }
        //#endregion

        return nextStep;
      }),
    );
  }
}
